import { Component } from '@angular/core';

@Component({
  selector: 'app-dinverify',
  templateUrl: './dinverify.component.html',
  styleUrls: ['./dinverify.component.css']
})
export class DinverifyComponent {
  ShowCard:any;
  
}
